// import logo from './logo.svg';
import '../../App.scss';
import React, { useState, useEffect } from "react";
import Banner from './main-banner/Banner.js';
import Navbar from './header/Navbar';
import Wedo from './wedo/Wedo.js';
import Industries from './Industries/Industries.js';
import Secure from './secure/Secure.js';
import Faqs from './faqs/Faqs.js';
import Workflows from './workflows/Workflows.js';
import Marquee from './marquee/Marquee.js';
import Clients from './clients/Clients.js';



function Landing() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])


  return (
    <>

      <Banner />
      <Marquee />
      <Wedo />
      {/* <Industries /> */}
      {/* <Secure /> */}
      <Faqs />
      <Clients />
      <Workflows />
    </>
  );
}

export default Landing;